var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLengehRail33Right2Right1Left(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 33.3",
    enableBackground: "new 0 0 66 33.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.8,1.5v30.3H43.6V1.5H63.8 M64.8,0.5H42.6v32.3h22.2V0.5L64.8,0.5z M58.8,6.5v20.3H48.6V6.5H58.8 M59.8,5.5H47.6v22.3 h12.2V5.5L59.8,5.5z M42.9,1.5 M42.9,1.5l1-1l0,0H22.2v32.3h21.7l-1-1H23.2V1.5H42.9 M42.4,6.5 M43.4,6.5v-1l0,0H27.2v22.3h16.2v-1 H28.2V6.5h14.2 M22.4,1.5 M22.4,1.5l1-1l0,0H1.7v32.3h21.7l-1-1H2.7V1.5H22.4 M21.9,6.5 M22.9,6.5v-1l0,0H6.7v22.3h16.2v-1H7.7V6.5 h14.2 M57.9,16.2h-5.5v1h5.5V16.2z M52.8,19.9v-6.6l-3.3,3.3L52.8,19.9z M10.6,17.2h5.5v-1h-5.5V17.2z M18.9,16.6l-3.3-3.3v6.6 L18.9,16.6z M31.1,17.2h5.5v-1h-5.5V17.2z M39.4,16.6l-3.3-3.3v6.6L39.4,16.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLengehRail33Right2Right1Left);
export default __webpack_public_path__ + "static/media/LENGEH_RAIL_3_3RIGHT_2RIGHT_1LEFT.951418c48fa4c511860bb6fb47ddc538.svg";
export { ForwardRef as ReactComponent };